module.exports = "https://r.nearpod.com/assets/media/image/live_zoom-301f98411ae6287f8c07bb78303fe9f0.svg";